import { Arg, Metadata } from '../../../../utils/spds/metadata';
import CloseButton from '../../action/button/close.gjs';
import FlexRow from '../../layout/flex/row.gjs';
import ProgressBar from '../../core/progress-bar.gjs';
import Super from '../../core/base.gjs';
import Title from './header/title.gjs';
import styles from './header.module.scss';

export const ACTIONS_GAP_DEFAULT = '11px';
export const ALIGN_ITEMS_DEFAULT = 'center';
export const JUSTIFY_CONTENT_DEFAULT = 'space-between';

const METADATA = Metadata.define({
  description: 'Header for full-screen modal with optional progress and close.',
  meta: {
    close: Arg.action({ description: 'Close action' }).required(),
    currentStep: Arg.number({ description: 'Current step index for progress bar' }),
    stepCount: Arg.number({ description: 'Total steps for progress bar' }),
    title: Arg.string({
      description: 'Header title',
      initialValue: 'Step title',
    }),
  },
  name: 'Header',
});

export default class SpdsModalFullScreenHeader extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-full-screen-header';
  styles = styles;

  get actionsGap() {
    return this.args.actionsGap ?? ACTIONS_GAP_DEFAULT;
  }

  get alignItems() {
    return this.args.alignItems ?? ALIGN_ITEMS_DEFAULT;
  }

  get justifyContent() {
    return this.args.justifyContent ?? JUSTIFY_CONTENT_DEFAULT;
  }

  get showProgressBar() {
    let { currentStep, stepCount } = this.args;
    return this.validateNumber(currentStep) && this.validateNumber(stepCount);
  }

  validateNumber(num) {
    return parseInt(num) >= 0;
  }

  <template>
    <FlexRow
      @alignItems={{this.alignItems}}
      @justifyContent={{this.justifyContent}}
      @tag="header"
      class={{this.classes}}
      data-test-spds-modal-full-screen-header
      {{this.validateArguments}}
      ...attributes
    >
      {{#if (has-block "title")}}
        {{yield to="title"}}
      {{else}}
        <Title @title={{@title}} />
      {{/if}}
      <FlexRow
        @gap={{this.actionsGap}}
        class="spds-modal-full-screen-header-actions"
        data-test-spds-modal-full-screen-header-actions
      >
        {{#if (has-block "additional-actions")}}
          <FlexRow
            @gap={{this.actionsGap}}
            class="spds-modal-full-screen-header-additional-actions"
            data-test-spds-modal-full-screen-additional-actions
          >
            {{yield to="additional-actions"}}
          </FlexRow>
        {{/if}}
        <CloseButton @close={{@close}} data-test-spds-modal-full-screen-close-button />
      </FlexRow>
      {{#if this.showProgressBar}}
        <ProgressBar
          @currentStep={{@currentStep}}
          @stepCount={{@stepCount}}
          class="spds-modal-full-screen-progress-bar"
        />
      {{/if}}
    </FlexRow>
  </template>
}

export const MODAL_FULL_SCREEN_HEADER_METADATA = SpdsModalFullScreenHeader.metadata;
